import React, { ChangeEvent } from "react";
import './Input.css'

interface InputProps {
	id: string
	label: string
	description?: string
	placeholder?: string
	isRequired?: boolean
	value: string
	onChange: (value: string) => void
}

const Input: React.FC<InputProps> = ({
	id,
	label,
	description,
	placeholder,
	isRequired = false,
	value,
	onChange
}) => {
	
	const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
		onChange(e.target.value)
	}

	return (
		<div className="input-container">
			<div className="input-label">
				<label htmlFor={id}>{label}</label>
				{isRequired && <span className="input-required">*</span>}
			</div>
			{description && <div className="input-description">{description}</div>}
			<textarea id={id} onChange={handleChange} value={value} placeholder={placeholder} />
		</div>
	)
}

export default Input